module.exports = __webpack_public_path__ + "static/media/Gabriel.049caf1a.png";